import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallTwoLineWithTimerProps } from './types';
import { bridge, isNil, isNotNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import type { IScreensLogging } from '../../../../api/types';
import { ViewAllButton } from '../ViewAllButton';
import { useCountdown } from '../../../../hooks/useCountdown';
import { useOpenDeeplink } from '../../../../hooks';

export const HeadlineSmallTwoLineWithTimer = ({
  header,
}: HeadlineSmallTwoLineWithTimerProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const handlePressViewAll = useCallback(() => {
    if (header?.item.deeplink) {
      logClickViewAllButton({ logging: header.logging });
      openDeeplink(header.item.deeplink);
    }
  }, [openDeeplink, header?.item.deeplink, header?.logging]);

  const { timeText: timerText } = useCountdown(header?.item.timer?.finished_at);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16 }}
      alignItems="center"
    >
      <Flex.Column
        gap={2}
        flex={1}
        padding={{ left: 16, right: hasDeeplink ? 0 : 16 }}
      >
        <Flex.Row gap={4} alignItems="center">
          <Typography type="h5" color="content_primary" numberOfLines={1}>
            {header.item.title}
          </Typography>
          {isNotNil(timerText) && (
            <Typography type="h5" color="content_pink_primary">
              {timerText}
            </Typography>
          )}
        </Flex.Row>
        {isNotNil(header.item.sub_title) && (
          <HTMLText type="body2" color="content_secondary">
            {header.item.sub_title}
          </HTMLText>
        )}
      </Flex.Column>

      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressViewAll} />
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickViewAllButton = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SMALL_TWO_LINE_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
